import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';
import Navigation from './Navigation';
import AdminForm from './AdminForm';
import PublicPetList from './PublicPetList';
import SignIn from './SignIn';
import PetDetail from './PetDetail';
import RegisterForm from './user/RegisterForm';
import AboutUs from './info/about';
import Contact from './info/contact';
import AdoptedPetsList from './adopciones/adoptados';
import { Analytics } from '@vercel/analytics/react';
import Timeline from './timeline/Timeline';
import TimelineForm from './timeline/TimelineForm';
import SocialContact from './info/SocialContact';
import RescuerForm from './RescuerForm';

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/signin" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <div className="App bg-gradient-to-br from-gray-50 via-white to-blue-50 min-h-screen">
        <Navigation />
        <Analytics />

        <div className="container mx-auto mt-8">
          <Routes>
            <Route path="/" element={<><Timeline /><SocialContact /><PublicPetList /></>} />
            <Route path="adopts" element={<AdoptedPetsList/>}/>
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/submit-pet" element={<RescuerForm />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/pet/:petId" element={<PetDetail />} />
            <Route
              path="/register"
              element={
                <ProtectedRoute>
                  <RegisterForm />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminForm />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/:petId" 
              element={
                <ProtectedRoute>
                  <AdminForm />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/timeline" 
              element={
                <ProtectedRoute>
                  <TimelineForm />
                </ProtectedRoute>
              } 
            />
            
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;